import { CurrencyTokenType as s } from "../../../currency-lib/constants/currency.js";
import { currencyTokenTypeSchema as r } from "../../../currency-lib/deserialize/yup/currency.js";
import * as o from "ramda";
import * as e from "yup";
const i = e.array().of(e.number()).default([]), d = e.object({
  backgroundColor: e.string().default("#d3d3d3"),
  cost: e.lazy((t) => {
    const n = o.keys(t), a = o.reduce(
      (m, c) => o.assoc(c, i, m),
      {},
      n
    );
    return e.object(a).required().noUnknown(!0);
  }),
  name: e.string().default(""),
  type: e.string().default("")
}).camelCase(), u = e.object({
  conjunctButtonText: e.string().default(""),
  addressConfig: e.string().default(""),
  bloodline: e.boolean().default(!1),
  image: e.string().default(""),
  imageLite: e.string().default(""),
  name: e.string().default(""),
  type: r,
  erc20: e.boolean().default(!1),
  cost: e.object({
    bloodline: e.boolean().default(!1),
    firstGeneration: e.boolean().default(!1)
  }),
  discountedBy: e.object({
    image: e.string().default(""),
    imageLite: e.string().default(""),
    name: e.string().default(""),
    type: r.optional()
  }).optional()
}).from("metaKey.conjunctButtonText", "conjunctButtonText").from("metaKey.addressConfig", "addressConfig").from("metaKey.bloodline", "bloodline").from("metaKey.image", "image").from("metaKey.imageLite", "imageLite").from("metaKey.name", "name").from("metaKey.type", "type").from("metaKey.erc20", "erc20").from("metaKey.cost", "cost").noUnknown(!0), y = e.object(
  Object.values(s).reduce((t, n) => ({
    ...t,
    [n]: e.lazy(
      (a) => a ? u : e.mixed().notRequired()
    )
  }), {})
).transform((t) => o.prop("meta_key", t));
export {
  d as conjunctCostMapSchema,
  y as conjunctItemSchema
};
//# sourceMappingURL=conjunct.js.map
